import { render, staticRenderFns } from "./detallePedido.vue?vue&type=template&id=4758b7be&scoped=true&"
import script from "./detallePedido.vue?vue&type=script&lang=js&"
export * from "./detallePedido.vue?vue&type=script&lang=js&"
import style0 from "./detallePedido.vue?vue&type=style&index=0&id=4758b7be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4758b7be",
  null
  
)

export default component.exports